<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Closed Tickets</h5>
            </div>
            <div class="card">
                <div class="p-d-flex p-ai-center p-flex-column p-flex-lg-row p-mb-1">
                    <div class="p-d-flex p-mr-3">
                        <Dropdown v-model="client_name" :options="clientList" @change="getNewTickets($event)"
                            optionLabel="label" appendTo="body" class="p-text-capitalize" placeholder="Select admin"
                            :style="{ minWidth: '200px' }" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Toolbar v-if="client_name != ''">
        <template v-slot:left>
            <Button icon="pi pi-user" label="My Tickets" text raised
                :class="myAssignedAndTeamTicketStatus == 2 ? 'p-mr-2 p-button' : 'p-mr-2 p-button-outlined'"
                @click="getMyTickets()" />
            <Button icon="pi pi-users" label="Team's Tickets" text raised
                :class="myAssignedAndTeamTicketStatus == 2 ? 'p-mr-2 p-button-outlined' : 'p-mr-2 p-button'"
                @click="getMyTeamsTickets()" />
        </template>

        <template v-slot:right>
            <Button label="Filter" icon="pi pi-filter-slash" @click="filterlisting()"></Button>
        </template>
    </Toolbar>
    <Toast />
    <div class="p-grid" v-if="client_name != ''">
        <div class="p-col-12">
            <div class="card">
                <DataTable :value="openTicketList" :lazy="true" :paginator="true" :rows="30"
                    :totalRecords="totalRecords" :loading="loading" @page="onPage($event)" class="p-datatable-users"
                    data-key="sa1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">

                    <template #empty> No data found. </template>

                    <template #loading> Loading data Please wait... </template>
                    <Column bodyStyle="width: 5%"></Column>
                    <Column field="ticketnumber" header="Ticket" headerStyle="width: 10%" bodyStyle="width: 2%">
                        <template #body="{ data }">
                            <div class="datatable-label-group mb-0" style="text-align: center;">
                                <div class="indigo-color ">{{ data.sa1 ? data.sa1 : "N/A" }}</div>
                            </div>
                        </template>
                    </Column>

                    <Column header="Created Details" headerStyle="width: 40%">
                        <template #body="{ data }">
                            <div>
                                <div class="p-mb-1"><span class="p-text-bold">Ticket Created :</span></div>
                                <div>{{ data.sa31 ?
                                    data.sa31 : 'N/A' }}</div>
                                <div class="p-mb-1">
                                    <span class="p-text-bold">on</span> <span class="p-text-capitalize">{{ data.sa12 ?
                                        format_timestamp(data.sa12) : 'N/A' }}</span>
                                    <span class="p-text-capitalize" v-if="data.created_by_designation">
                                        ({{ data.created_by_designation ? data.created_by_designation : 'N/A' }})
                                    </span>
                                </div>
                            </div>
                            <Divider type="dashed" class="p-my-2" />
                            <div>
                                <div class="p-mb-1">
                                    <span class="p-text-bold">Ticket Assign To : </span>
                                    <div class="p-text-capitalize">{{ data.sa17 ? data.sa17 : 'N/A' }}</div>
                                </div>
                                <div><span class="p-text-bold">on</span> <span>{{ data.sa13 ?
                                    format_timestamp(data.sa13) : 'N/A' }}</span></div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Ticket Details" headerStyle="width: 40%">
                        <template #body="{ data }">
                            <div>
                                <div>
                                    <span class="p-text-bold">Ticket Opened :</span>
                                    <div>{{ data.sa15 ? data.sa15 : 'N/A' }}</div>
                                </div>
                                <span class="p-text-bold">on</span> <span class="p-text-capitalize">{{ data.sa13 ?
                                    format_timestamp(data.sa13) : 'N/A' }}</span>
                            </div>
                            <Divider type="dashed" class="p-my-2" />
                            <div>
                                <div class="p-mb-1"><span class="p-text-bold">Ticket Closed :</span>
                                </div>
                                <div>{{ data.sa34 ? data.sa34 : 'N/A' }}</div>
                            </div>
                            <div>
                                <span class="p-text-bold">on</span> <span class="p-text-capitalize">{{ data.sa32 ?
                                    format_timestamp(data.sa32) : 'N/A' }}</span>
                            </div>
                            <Divider type="dashed" class="p-my-2" />
                            <div>
                                <div class="p-text-bold">Total Time Taken :</div>
                                <span>{{ working_time(data) }}</span>
                            </div>

                        </template>
                    </Column>
                    <Column header="User Detail" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <div v-if="data.sa39 == 3">
                                <div class="datatable-label-group mb-2">
                                    <label class="p-text-bold raised-from">Police</label>
                                </div>
                            </div>
                            <div v-else-if="data.sa39 == 4">
                                <div class="datatable-label-group mb-2">
                                    <label class="p-text-bold raised-from">Citizen</label>
                                </div>
                            </div>
                            <Divider type="dashed" class="p-my-2" />
                            <div class="datatable-label-group mb-2">
                                <label class="p-text-bold">Type | Brand</label>
                                <div class="from-label-value overflow-span">{{ JSON.parse(data.sa43)?.mobile_type == "1"
                                    ? "Android" : "iOS" }} | <span class="p-text-capitalize">{{ data.sa43 ?
                                        JSON.parse(data.sa43).name : "N/A" }}</span></div>
                                <Divider type="dashed" class="p-my-2" />
                            </div>
                            <div class="datatable-label-group mb-2">
                                <label class="p-text-bold">Model name</label>
                                <div class="from-label-value overflow-span">{{ data.sa43 ? JSON.parse(data.sa43).model :
                                    "N/A" }}</div>
                            </div>
                            <Divider type="dashed" class="p-my-2" />
                            <div class="datatable-label-group mb-2">
                                <label class="p-text-bold">Mobile version</label>
                                <div class="from-label-value overflow-span">{{ data.sa43 ?
                                    JSON.parse(data.sa43).system_version : "N/A" }}</div>
                            </div>
                        </template>
                    </Column>
                    <Column header="Description" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-jc-between ">
                                <div v-if="data.sb5 != null" style="width: 100%;">
                                    <span class="p-text-bold">Description : </span>
                                    <span v-if="!activate_read_key_arr.includes(data.sa1)" class="w-100"
                                        style="word-wrap: break-word; white-space: normal; width: 100% ;">
                                        {{ data.sb5.slice(0, 140).replaceAll('*', '') }}
                                    </span>
                                    <a v-if="data.sb5.length >= 140 && !activate_read_key_arr.includes(data.sa1)"
                                        @click="activateReadMore(data.sa1)" class="showmore p-ml-2">read more</a>
                                    <span v-if="activate_read_key_arr.includes(data.sa1)"
                                        v-html="data.sb5.replaceAll('*', '')"
                                        style="word-wrap: break-word; white-space: normal;"></span>
                                    <span>
                                        <a v-if="data.sb5.length >= 140 && activate_read_key_arr.includes(data.sa1)"
                                            @click="deactivateReadMore(data.sa1)" class="showless p-ml-2"
                                            style="word-wrap: break-word; white-space: normal;">read less</a>
                                    </span>
                                </div>
                                <div v-else><span class="p-text-bold">Description : </span>N/A</div>
                            </div>
                            <Divider type="dashed" class="p-my-2" />
                            <div class="p-text-right" v-if="data.sa39 == 1"><Button label="Login as Admin"
                                    severity="info" class="p-button-text p-ml-auto"
                                    @click="loginAsClientDialogOpen(data)" /></div>
                        </template>
                    </Column>
                    <Column header="Support Action" headerStyle="width: 25%">
                        <template #body="{ data }">
                            <div class="p-d-flex p-jc-between">
                                <div><Button label="Show History" severity="info" @click="showHistoryDialogOpen(data)"
                                        class="p-button p-component p-button-text p-py-0" />
                                </div>
                            </div>
                        </template>
                    </Column>
                </DataTable>
                <Toast />
            </div>
        </div>
    </div>
    <!-- show history dialog start here -->
    <div class="modal-mask">
        <Dialog v-model:visible="showHistoryDialogStatus" :style="{ width: '1000px' }" header="Ticket History"
            :modal="true" class="p-fluid">
            <div class="card custom-ticket-header" ref="chatBoxElement">
                <Toast />
                <div class="p-pt-2 p-px-3">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-3 p-mb-0">
                            <div><span class="p-text-bold">Admin Name :</span> <span class="p-text-capitalize"> {{
                                this.ticketHistoryData.sa3 ? this.ticketHistoryData.sa3 : 'N/A' }}</span> </div>
                            <div v-if="this.ticketHistoryData.sa39 == 2"><span class="p-text-bold">Host Name :</span>
                                <span class="p-text-capitalize"> {{
                                    this.ticketHistoryData.sa38 ? this.ticketHistoryData.sa38 : 'N/A' }}</span>
                            </div>
                            <div class="p-text-capitalize" v-if="ticketHistoryData.branchname">
                                <span class="p-text-bold">Branch Name :</span>
                                {{ this.ticketHistoryData.branchname ? this.ticketHistoryData.branchname : 'N/A' }}
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-md-3 p-mb-0">
                            <div><span class="p-text-bold">Ticket No :</span> {{ this.ticketHistoryData.sa4 ?
                                this.ticketHistoryData.sa4 : 'N/A' }} </div>
                        </div>
                        <div class="p-field p-col-12 p-md-4 p-mb-0">
                            <div class="p-mb-1"><span class="p-text-bold">Ticket By :</span> <span
                                    class="p-text-capitalize">{{
                                        this.ticketHistoryData.sa31 ? this.ticketHistoryData.sa31 : 'N/A' }}</span>
                                <span class="p-text-capitalize" v-if="this.ticketHistoryData.created_by_designation">
                                    ({{ this.ticketHistoryData.created_by_designation ?
                                        this.ticketHistoryData.created_by_designation
                                        : 'N/A' }})</span>
                            </div>
                            <div v-if="this.ticketHistoryData.sa42 != '' && this.ticketHistoryData.sa42 != null"
                                class="p-d-flex p-dir-row p-ai-center"><Button icon="pi pi-phone"
                                    class="ticket-custom-call-btn p-button-success"
                                    @click="triggerCallToMeraNetaClients(this.ticketHistoryData)"
                                    :disabled="isDisabled">
                                </Button>+91{{ this.ticketHistoryData.sa42 ? this.ticketHistoryData.sa42 : 'N/A'
                                }}
                            </div>
                        </div>
                        <div class="p-field p-col-12 p-md-2 p-mb-0">
                            <div><span class="p-text-bold ticket-created-since">{{ this.ticketHistoryData.sa32 ?
                                calculateDaysDifference(this.ticketHistoryData.sa32) : 'N/A' }} </span> </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ticket-chat-box-outer">
                <div class="history-conversation-inner">
                    <div v-for="msg in ticketMessage" :key="msg">
                        <div class="msg-body-align-left" v-if="msg.sb8 == 1">
                            <div class="p-d-flex p-jc-between custom-datetime-label">
                                <span class="p-text-bold p-text-capitalize">{{ msg.sb11 ? msg.sb11 : 'N/A' }}</span>
                                <span class="msg-datetime-left">{{ msg.z501 ? format_timestamp(msg.z501) : 'N/A'
                                }}</span>
                            </div>
                            <span class="image-profile-outer-left"><img
                                    v-if="msg.profileimageurl == null || msg.profileimageurl == ''"
                                    src="/assets/layout/images/widgets/asset-profile-11.png" class="custom-profile-chat"
                                    alt="" width="32" height="32" />
                                <img v-if="msg.profileimageurl != null && msg.profileimageurl != ''"
                                    class="custom-profile-chat"
                                    :src="'https://storage.googleapis.com/' + this.master_bucket_name + '/visitor/profile/' + msg.profileimageurl"
                                    alt="" width="32" height="32" />
                            </span>
                            <div class="message-body-left-arrow">
                                <div class="left-arrow-outer"></div>
                                <div class="left-arrow-inner"></div>
                            </div>
                            <div class="message-body-left">
                                <span style="word-wrap: break-word; white-space: normal;">
                                    {{ msg.sb5 ? msg.sb5 : 'N/A' }}
                                </span>
                            </div>

                            <div v-if="msg.sb14 != '' && msg.sb14 != null">
                                <span class="attachment-left"><i class="pi pi-paperclip me-1"></i>Attachment's : </span>
                                <span v-for="(value, key) in splitJoin(msg.sb14)" :key="key">
                                    <img :src="value" alt="" width="32" height="32" class="attach-file"
                                        @click="previewImageModalOpen(value)" />
                                </span>
                            </div>

                        </div>

                        <div class="msg-body-align-right" v-if="msg.sb8 == 2">
                            <div class="p-d-flex p-jc-between custom-datetime-label">
                                <span class="msg-datetime-right">{{ msg.z501 ? format_timestamp(msg.z501) : 'N/A'
                                }}</span>
                                <span class="p-text-bold p-text-capitalize"><span >{{ msg.sb11 ? msg.sb11 : 'N/A'
                                }}</span></span>
                            </div>
                            <div>
                                <span class="image-profile-outer-right"><img
                                        v-if="msg.profileimageurl == null || msg.profileimageurl == ''"
                                        src="/assets/layout/images/widgets/asset-profile-11.png"
                                        class="custom-profile-chat" alt="" width="32" height="32" />
                                    <img v-if="msg.profileimageurl != null && msg.profileimageurl != ''"
                                        :src="msg.profileimageurl" class="custom-profile-chat" alt="" width="32"
                                        height="32" />
                                </span>
                                <div class="message-body-right-arrow">
                                    <div class="right-arrow-outer"></div>
                                    <div class="right-arrow-inner"></div>
                                </div>
                                <div class="message-body-right">
                                    <span style="word-wrap: break-word; white-space: normal;">
                                        {{ msg.sb5 ? msg.sb5 : 'N/A' }}
                                    </span>
                                </div>
                            </div>
                            <div v-if="msg.sb14 != '' && msg.sb14 != null" class="attachment-right-outer">
                                <span class="attachment-right"><i class="pi pi-paperclip me-1"></i>Attachment's :
                                </span>
                                <span v-for="(value, key) in splitJoin(msg.sb14)" :key="key">
                                    <img :src="value" alt="" width="32" height="32" class="attach-file"
                                        @click="previewImageModalOpen(value)" />
                                </span>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="p-pt-2 p-px-3">
                    <TabView class="tabview-custom">
                        <TabPanel>

                            <template #header>
                                <div class="flex align-items-center gap-2">
                                    <i class="pi pi-file"></i>
                                    <span class="font-bold white-space-nowrap"> Call Recordings</span>
                                </div>
                            </template>
                            <div>No Records Found
                            </div>
                        </TabPanel>

                    </TabView>
                </div>
            </div>

            <template #footer>
                <div>

                </div>
            </template>
        </Dialog>
    </div>
    <!-- show history dialog end here -->
    <!-- Preview screen images start here -->
    <Dialog v-model:visible="imagePreviewDialog" :style="{ width: '1000px' }" header="Preview" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                    <img :src="imgsourcepath" style="vertical-align: middle; width: 100%;" />
                </div>
            </div>
        </div>
    </Dialog>
    <!-- Preview screen images end here -->

    <!----Start of filter--------------------------------->
    <Dialog v-model:visible="filterListingDialog" :style="{ width: '600px' }" header="Filter" :modal="true"
        class="p-fluid">
        <div class="p-pt-2 p-px-3">
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12">
                    <label for="client">Admin</label>
                    <MultiSelect v-model="filterListing.client_fks" :options="clientList" optionValue="value"
                        optionLabel="label" placeholder="Select Admin" :filter="true" class="multiselect-custom"
                        appendTo="body"></MultiSelect>
                </div>
                <div class="p-field p-col-12">
                    <label for="didnumber">
                        Ticket Number
                    </label>
                    <InputText id="ticketnumber" v-model.trim="filterListing.ticketnumber" maxlength="8"
                        @keypress="onlyNumber" placeholder="Enter Ticket Number"  />
                </div>
                <div class="p-field p-col-12">
                    <label for="fromdate">Ticket Created Date</label>
                    <Calendar :showIcon="true" :monthNavigator="true" :yearNavigator="true"
                        v-model="filterListing.createdDate" :maxDate="todaysDate" placeholder="DD/MM/YYYY"
                        dateFormat="dd/mm/yy" :yearRange="'2020:' + new Date().getFullYear()" appendTo="body"
                        required="true" :manualInput="false"
                        :class="{ 'p-invalid': submitted && !filterListing.createdDate }"></Calendar>
                </div>
            </div>
        </div>

        <template #footer>
            <Button label="Reset" icon="pi pi-refresh" class="p-button-text" @click="reSetFilteredData()" />
            <Button label="Search" icon="pi pi-search" class="p-mr-2" autofocus
                @click="getFilteredData(filterListing.client_fks, filterListing.ticketnumber, filterListing.createdDate)" />
        </template>
    </Dialog>
    <!----End of filter--------------------------------->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { } from '@vuelidate/validators';
import moment from 'moment';
export default {
    data() {
        return {
            v$: useValidate(),
            page_no: 0,
            totalRecords: 0,
            loading: false,
            showHistoryDialogStatus: false,
            filterListingDialog: false,
            openTicketList: [],
            submitted: false,
            showFillFilter: false,
            ticketHistoryData: '',
            ticketMessage: '',
            imagePreviewDialog: false,
            imgsourcepath: null,
            myAssignedAndTeamTicketStatus: 2, // 2 for my assigned and 1 for my team assigned ticket
            clientList: [],
            filterListing: {
                client_fks: [],
                ticketnumber: '',
                createdDate: null
            },
            isDisabled: false,
            todaysDate: new Date(),
            showingFullText: false,
            activate_read_key_arr: [],
            client_name: '',
        };
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        this.client_info = JSON.parse(localStorage.getItem('masterBucketName'));
        this.master_bucket_name = this.client_info;
        this.loading = true;
        this.getClientList();
    },
    validations() {
        return {

        };
    },
    methods: {
        activateReadMore(e) {
            this.activate_read_key_arr.push(e);
        },
        deactivateReadMore(e) {
            var index = this.activate_read_key_arr.indexOf(e);
            if (index !== -1) {
                this.activate_read_key_arr.splice(index, 1);
            }
        },
        splitJoin(theText) {
            return theText.split(',');
        },
        previewImageModalOpen(e) {
            this.imagePreviewDialog = true;
            this.imgsourcepath = e;
        },

        getMyAndTeamAssignTicket(ev) {
            this.loading = true;
            this.ApiService.getMyAndTeamAssignTicket(ev).then((data) => {
                if (data.status == 200) {
                    this.openTicketList = data.data;
                    this.totalRecords = data.count;
                } else {
                    this.openTicketList = [];
                }
                this.loading = false;
            });
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getMyAndTeamAssignTicket({ maa1: this.clientsId, page_no: this.page_no, status: 3, flag: this.myAssignedAndTeamTicketStatus, sa4: this.filterListing.ticketnumber, sa2: this.filterListing.client_fks, sa12: this.filterListing.createdDate });
        },
        getMyTickets() {
            this.getMyAndTeamAssignTicket({ maa1: this.clientsId, page_no: this.page_no, status: 3, flag: 2 });
            this.myAssignedAndTeamTicketStatus = 2;
        },
        getMyTeamsTickets() {
            this.getMyAndTeamAssignTicket({ maa1: this.clientsId, page_no: this.page_no, status: 3, flag: 1 });
            this.myAssignedAndTeamTicketStatus = 1;
        },

        getTicketsMessages(e) {
            this.ApiService.getTicketsMessage({ sa1: e.sa1, sa2: e.sa2 }).then((data) => {
                if (data.status == 200) {
                    this.ticketMessage = data.data.ticket_messages;
                    this.showHistoryDialogStatus = true;
                } else {
                    this.ticketMessage = null;
                }
                this.loading = false;
            });
        },
        showHistoryDialogOpen(e) {
            this.ticketHistoryData = e;
            this.loading = true;
            this.submitted = false;
            this.getTicketsMessages(e);
        },
        getNewTickets(e) {
            this.clientsId = e.value.value;
            this.getMyAndTeamAssignTicket({ maa1: this.clientsId, page_no: this.page_no, status: 3, flag: this.myAssignedAndTeamTicketStatus });
        },

        filterlisting() {
            this.getClientList();
            this.filterListingDialog = true;
        },
        getClientList() {
            this.ApiService.getAdminListOnly().then((data) => {
                if (data.status == 200) {
                    this.clientList = data.data.records;
                    this.client_name = this.clientList[0];
                    if (this.client_name != null && this.client_name != '') {
                        this.getNewTickets({ value: this.clientList[0] });
                    }
                } else {
                    this.clientList = null;
                }
            });
        },
        onlyNumber($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
                $event.preventDefault();
            }
        },
        getFilteredData(client_fks, ticketnumber, createdDate) {
            this.loading = true;
            this.filterListing.client_fks = client_fks;
            this.filterListing.ticketnumber = ticketnumber;
            if (createdDate != "" && createdDate != null) {
                this.filterListing.createdDate = moment(createdDate).format("YYYY-MM-DD");
            }
            this.getMyAndTeamAssignTicket({
                maa1: this.clientsId, page_no: this.page_no, status: 3, flag: this.myAssignedAndTeamTicketStatus, sa4: ticketnumber, sa2: client_fks, sa12: this.filterListing.createdDate
            });
            this.filterListingDialog = false;
        },
        reSetFilteredData() {
            this.filterListing.client_fks = '';
            this.filterListing.ticketnumber = '';
            this.filterListing.createdDate = '';
            this.filterListingDialog = false;
        },
        triggerCallToMeraNetaClients(data) {
            this.isDisabled = true;
            this.ApiService.triggercalltomeranetaclients({ mobile_number: data.sa42, sa2: data.sa2, sa4: data.sa4, sa30: data.sa30, sa31: data.sa31 }).then(
                (items) => {
                    if (items.success === true) {
                        this.isDisabled = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                    } else {
                        this.isDisabled = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                }
            );
        },
        format_timestamp(value) {
            if (value) {
                var localTime = new Date(value * 1000).toUTCString();
                return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
            } else {
                return '-';
            }
        },
        working_time(value) {
            let start_time = value.sa13
            let end_time = value.sa32

            let time1 = new Date(start_time * 1000);
            let time2 = new Date(end_time * 1000);
            let diff = time2 - time1;
            let hours = Math.floor(diff / 3.6e6);
            let Days = Math.floor(hours / 24);
            let minutes = Math.floor((diff % 3.6e6) / 6e4);
            if (minutes < 0) {
                return '00' + ':' + '00';
            } else if (Days <= 0) {
                return hours + ' Hours ' + minutes + ' Minutes';
            } else if (Days > 0) {
                var Remainder = hours % 24;
                var Hours = Math.floor(Remainder);
                return Days + ' Days ' + Hours + ' Hours ';
            }
        }

    },
};
</script>

<style scoped lang="scss">
.user-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-active {
        background: #c8e6c9;
        color: #256029;
    }

    &.status-per-suspend {
        background: #ffcdd2;
        color: #c63737;
    }

    &.status-temp-suspend {
        background: #ffd8b2;
        color: #805b36;
    }
}

.custom-scroll {
    background: #e4ded9;
    border-radius: 5px;
    padding: 0.25em 0.5rem;
}

.msg-left {
    float: left;
    width: 80%;
    padding: 5px;
}

.msg-right {
    float: right;
    width: 80%;
    padding: 5px;
}

.arrow {
    width: 12px;
    height: 20px;
    overflow: hidden;
    position: relative;
    float: left;
    top: 6px;
    right: -1px;
}

.arrow .outer {
    width: 0;
    height: 0;
    border-right: 20px solid #000000;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    position: absolute;
    top: 0;
    left: 0;
}

.arrow .inner {
    width: 0;
    height: 0;
    border-right: 20px solid #ffffff;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    position: absolute;
    top: 0;
    left: 2px;
}

.message-body {
    float: left;
    width: 80%;
    height: auto;
    border: 1px solid #CCC;
    background-color: #ffffff;
    border: 1px solid #000000;
    padding: 6px 8px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -o-border-radius: 5px;
    border-radius: 5px;
}

.message-body p {
    margin: 0;
}

.image {
    float: left;
}

.msg-datetime-left {
    position: relative;
    float: right;
    margin-right: 100px;
}

.msg-datetime-right {
    position: relative;
    float: right;
    margin-right: 100px;
}


.arrow-right {
    width: 12px;
    height: 20px;
    overflow: hidden;
    position: relative;
    float: left;
    top: 6px;
    left: -1px;
}

.arrow-right .outer-right {
    width: 0;
    height: 0;
    border-left: 20px solid #000000;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    position: absolute;
    top: 0;
    right: 0;
}

.arrow-right .inner-right {
    width: 0;
    height: 0;
    border-left: 20px solid #ffffff;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    position: absolute;
    top: 0;
    right: 2px;
}

.custom-btn-class {
    margin-left: 45px;
    margin-bottom: -8px;
}

.custom-status {
    margin-left: 75px;
}

.attachment {
    float: left;
    margin-top: 5px;
}

.attach-file {
    float: left;
    padding: 1px;
}

.ticket-created-since {
    padding: 7px 15px;
    border: 1px solid #1565C0;
    border-radius: 15px;
    background-color: #1565C0;
    color: white;
}
.raised-from{
    background: #cfeba2;
    padding: 4px 6px;
}
</style>

<style lang="scss" scoped>
/* Responsive */
.p-datatable-customers .p-datatable-tbody>tr>td .p-column-title {
    display: none;
}

.p-button-xs {
    width: 1rem;
}

.p-button.p-button-xs {
    padding: 0.925rem 0.925rem;
}

.p-button.p-button-xs .p-button-icon {
    font-size: 0.675rem;
}

.p-button.p-button-xs.p-button-icon-only.p-button-rounded {
    height: 1rem;
}


::v-deep(.p-progressbar) {
    height: 1rem;
    background-color: #d8dadc;

    .p-progressbar-value {
        background-color: #689f38;
    }

    .p-progressbar-label {
        display: block;
        color: #ffffff;
        line-height: 13px;
        font-size: 0.9rem;
    }
}

@media screen and (max-width: 960px) {
    ::v-deep(.p-datatable) {
        &.p-datatable-customers {

            .p-datatable-thead>tr>th,
            .p-datatable-tfoot>tr>td {
                display: none !important;
            }

            .p-datatable-tbody>tr {
                border-bottom: 1px solid #dee2e6;

                >td {
                    text-align: left;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 0 none !important;
                    width: 100% !important;
                    float: left;
                    clear: left;
                    border: 0 none;

                    .p-column-title {
                        padding: 0.4rem;
                        min-width: 30%;
                        display: inline-block;
                        margin: -0.4rem 1rem -0.4rem -0.4rem;
                        font-weight: bold;
                    }

                    .p-progressbar {
                        margin-top: 0.5rem;
                    }
                }
            }
        }
    }
}
</style>